/**
 * @module services/api-upload/omitEmptyCustomizeSetting
 * @description 内层 storage 切片均无有效字段时 omit customizeSetting
 */

/** 内层 storage 切片均无有效字段 → undefined（请求可 omit customizeSetting） */
export function omitEmptyCustomizeSetting(
  customizeSetting: Record<string, Record<string, unknown>> | undefined,
): Record<string, unknown> | undefined {
  if (!customizeSetting || typeof customizeSetting !== 'object') {
    return undefined;
  }
  const keys = Object.keys(customizeSetting);
  if (keys.length === 0) {
    return undefined;
  }
  const hasPayload = keys.some(key => {
    const inner = customizeSetting[key];
    return (
      inner &&
      typeof inner === 'object' &&
      !Array.isArray(inner) &&
      Object.keys(inner as Record<string, unknown>).length > 0
    );
  });
  return hasPayload
    ? (customizeSetting as Record<string, unknown>)
    : undefined;
}
